/**
 * M2, passo 3 — checklist leve do emissor do Registro de Atividade.
 *
 * Espelho do `AttendanceUploadModal/self-check.ts`, com a mesma regra de ouro:
 * **nenhum item é obrigatório**. O que o emissor marcar (e o que deixar em
 * branco) vira evento na trilha do registro, e o auditor lê isso ANTES de abrir
 * o anexo. Puro de propósito — o texto é o que o teste verifica, sem montar
 * componente.
 */

/** Chaves do checklist, na ordem em que o mockup lista os itens. */
export type ActivitySelfCheckKey = 'attachmentsLegible' | 'dateAndTimeVisible' | 'nothingCropped'

export interface ActivitySelfCheckItem {
  key: ActivitySelfCheckKey
  label: string
}

export type ActivitySelfCheckState = Record<ActivitySelfCheckKey, boolean>

/** Nenhum item vem pré-marcado: marcar é a declaração, e um default `true` a falsificaria. */
export function emptyActivitySelfCheckState(): ActivitySelfCheckState {
  return {
    attachmentsLegible: false,
    dateAndTimeVisible: false,
    nothingCropped: false
  }
}

/**
 * Os 3 itens do mockup. A data entra no texto porque é o que o emissor tem de
 * conferir no anexo que está na mão dele — um rótulo genérico não confere nada.
 */
export function buildActivitySelfCheckItems(params: {
  formattedDate: string
}): ActivitySelfCheckItem[] {
  return [
    { key: 'attachmentsLegible', label: 'Os anexos estão legíveis e na orientação certa' },
    {
      key: 'dateAndTimeVisible',
      label: params.formattedDate
        ? `A data ${params.formattedDate} e o horário aparecem no anexo`
        : 'A data e o horário aparecem no anexo'
    },
    { key: 'nothingCropped', label: 'Nada essencial ficou cortado nas bordas' }
  ]
}

/**
 * Payload do campo `selfCheck` do multipart. Item desmarcado vai como `false`: é
 * exatamente a informação que o auditor precisa ("foi confessado antes de abrir
 * o anexo").
 */
export function buildActivitySelfCheckPayload(
  state: ActivitySelfCheckState
): ActivitySelfCheckState {
  return {
    attachmentsLegible: state.attachmentsLegible === true,
    dateAndTimeVisible: state.dateAndTimeVisible === true,
    nothingCropped: state.nothingCropped === true
  }
}
